import React, { useState } from "react";
import Stepper from "../../../components/Stepper/Stepper";
import FormInput from "./FormInput";

export default function CreateSignupForm({
  schema,
  onChange,
  userInfo,
  cancelRegistration,
  showError,
  loading,
}) {
  const [currentStep, setCurrentStep] = useState(0);
  const steps = ["Personal and Login", "Employment Info"];

  const handleNext = (e) => {
    e.preventDefault();

    const requiredFields = [
      "firstName",
      "lastName",
      "mobileNumber",
      "email",
      "username",
      "password",
      "confirmPassword",
    ];
    const emptyFields = requiredFields.filter(
      (field) => !userInfo[field] || userInfo[field].toString().trim() === ""
    );

    if (emptyFields.length > 0) {
      showError(`
      Please fill out all fields 
    `);
      return;
    }

    if (userInfo.password !== userInfo.confirmPassword) {
      showError(`Password not match`);
      return;
    }

    setCurrentStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleCancel = () => {
    cancelRegistration();
  };

  const getSections = () => {
    const sectionNames =
      currentStep === 0
        ? ["Personal Information", "Login Information"]
        : ["Affiliate and Branches", "Employment Details"];

    return sectionNames.map((name) =>
      schema.sections.find((section) => section.name === name)
    );
  };

  return (
    <div>
      <div className="pb-5">
        <Stepper steps={steps} currentStep={currentStep} />
      </div>
      <FormInput
        sections={getSections()}
        onChange={onChange}
        userInfo={userInfo}
      />
      <div className="w-100 d-flex justify-content-center gap-3 pt-5">
        <button
          className="btn btn-light p-2 ps-4 pe-4"
          type="button"
          onClick={currentStep === 0 ? handleCancel : handleBack}
        >
          {currentStep === 0 ? "Cancel" : "Back"}
        </button>
        <button
          className="btn btn-primary p-2 ps-4 pe-4"
          type={currentStep === 0 ? "button" : "submit"}
          onClick={currentStep === 0 ? handleNext : null}
          disabled={currentStep !== 0 && loading}
        >
          {currentStep !== 0 && loading ? "Please wait..." : currentStep === 0 ? "Next" : "Create Account"}
        </button>
      </div>
    </div>
  );
}
